
// Use native fetch in browser (node-fetch not needed for client-side)
const fetch = typeof window !== 'undefined' ? window.fetch.bind(window) : null
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

import ApolloClient from 'apollo-client'
import gql from 'graphql-tag'

class LoginApi {
  constructor (request) {
    this.initApolloClient()
  }
  set request (request) {
    this._request = request
  }
  initApolloClient () {
    const isBrowser = typeof window !== 'undefined'

    const customFetch = (uri, options) => {
      // if this.request we are in SSR and need to pass cookies from the
      // original request
      if (this._request) {
        options.headers.cookie = this._request.headers.cookie
      }

      return fetch(uri, options)
    }

    const client = new ApolloClient({
      link: createHttpLink({
        uri: this.getBaseUrl() + '/gql',
        credentials: 'include',
        fetch: customFetch
      }),
      ssrMode: !isBrowser,
      onError: (e) => {
        console.warn(e)
      },
      cache: new InMemoryCache(),
      defaultOptions: {
        query: {
          fetchPolicy: 'network-only'
        }
      }
    })

    // @todo pablo - 2020-02-20 : create a getter so we can assure to return a
    // new client in SSR for every request, to assure we dont have any shared
    // data between request from different users
    this.apollo = {
      uri: this.getBaseUrl() + '/gql',
      query: async (request) => {
        let data = null
        try {
          data = await client.query(request)
        } catch (e) {
          console.warn(e)
          throw e
        }
        return data
      },
      mutate: async (request) => {
        let data = null
        try {
          data = await client.mutate(request)
        } catch (e) {
          console.warn(e)
          throw e
        }
        return data
      }
    }
  }

  getBaseUrl () {
    if (process.env.NODE_ENV === 'development') {
      const host = process.client
        ? window.location.hostname
        : 'localhost'

      return `http://${host}:3388`
    }

    return 'https://api.thevortex.io'
  }

  async cookie () {
    return this.apollo.query({
      variables: { },
      query: gql`{
        cookie
      }`
    })
  }
  async me () {
    return (await this.apollo.query({
      variables: { },
      query: gql`{
        me {
          _id
          name
          alias
          code
          email
          role
          avatar
        }
      }`
    })).data.me
  }

  async updateName (name) {
    return (await this.apollo.mutate({
      variables: { name },
      mutation: gql`mutation ($name: String!) {
        userUpdateName (name: $name) {
          _id
          name
          alias
          code
          email
          role
          avatar
        }
      }`
    })).data.updateAlias
  }
  async updateAlias (alias) {
    return (await this.apollo.mutate({
      variables: { alias },
      mutation: gql`mutation ($alias: String!) {
        userUpdateAlias (alias: $alias) {
          _id
          name
          alias
          code
          email
          role
          avatar
        }
      }`
    })).data.updateAlias
  }

  async socialRedirect (service) {
    return (await this.apollo.query({
      variables: { service },
      query: gql`query ($service: String!) {
        socialRedirect(service: $service)
      }`
    })).data.socialRedirect
  }
  async login (email, password) {
    return (await this.apollo.mutate({
      variables: { email, password },
      mutation: gql`mutation ($email: String!, $password: String!) {
        login (email: $email, password: $password) {
          _id
          name
          alias
          code
          email
          role
          avatar
        }
      }`
    })).data.login
  }
  async socialLogin (service, data) {
    return (await this.apollo.mutate({
      variables: { service: service, data: JSON.stringify(data) },
      mutation: gql`mutation ($service: String!, $data: String!) {
        socialLogin (service: $service, data: $data) {
          _id
          name
          alias
          code
          email
          role
          avatar
        }
      }`
    })).data.socialLogin
  }
  async logout () {
    return (await this.apollo.mutate({
      mutation: gql`mutation {
        logout
      }`
    })).data.logout
  }
}

export default new LoginApi()



// WEBPACK FOOTER //
// ./src/plugins/LoginApi.js